module.exports = __webpack_public_path__ + "static/media/10-dad-60th-08_15_2020.891ff9be.jpg";